// IDR-50 — Inventaire des Drivers Relationnels (bilingue FR / ES).
// 50 items, échelle de correspondance 0 %–100 %, 5 drivers (10 items chacun).

export const IDR_SCALE = {
  fr: [
    { value: 0, label: "Pas du tout" },
    { value: 25, label: "Un peu" },
    { value: 50, label: "Moyennement" },
    { value: 75, label: "Beaucoup" },
    { value: 100, label: "Totalement" },
  ],
  es: [
    { value: 0, label: "Nada" },
    { value: 25, label: "Un poco" },
    { value: 50, label: "Moderadamente" },
    { value: 75, label: "Bastante" },
    { value: 100, label: "Totalmente" },
  ],
};

export const DRIVERS = [
  { key: "sois_parfait", color: "#A3826A", items: [9, 19, 20, 25, 32, 33, 38, 44, 45, 46],
    name: { fr: "Sois parfait", es: "Sé perfecto" },
    description: { fr: "Exigence élevée, recherche de perfection, peur de l'erreur et de la critique.", es: "Alto nivel de exigencia, búsqueda de perfección, miedo al error y a la crítica." } },
  { key: "sois_fort", color: "#8A6D56", items: [1, 3, 4, 13, 14, 22, 24, 26, 42, 47],
    name: { fr: "Sois fort", es: "Sé fuerte" },
    description: { fr: "Retenue émotionnelle, autonomie, difficulté à demander de l'aide et à se livrer.", es: "Contención emocional, autonomía, dificultad para pedir ayuda y para abrirse." } },
  { key: "fais_plaisir", color: "#B58C67", items: [5, 11, 12, 17, 21, 23, 28, 39, 43, 49],
    name: { fr: "Fais plaisir", es: "Complace a los demás" },
    description: { fr: "Besoin d'être apprécié, de répondre aux attentes et de préserver la relation.", es: "Necesidad de ser apreciado, de responder a las expectativas y de preservar la relación." } },
  { key: "fais_efforts", color: "#B0553B", items: [6, 8, 10, 16, 30, 34, 36, 40, 48, 50],
    name: { fr: "Fais des efforts", es: "Esfuérzate" },
    description: { fr: "Valorisation de l'effort, tendance à se surcharger et à complexifier les choses.", es: "Valoración del esfuerzo, tendencia a sobrecargarse y a complicar las cosas." } },
  { key: "depeche_toi", color: "#C08552", items: [2, 7, 15, 18, 27, 29, 31, 35, 37, 41],
    name: { fr: "Dépêche-toi", es: "Date prisa" },
    description: { fr: "Sentiment d'urgence intérieure, difficulté à ralentir et à attendre.", es: "Sensación de urgencia interior, dificultad para ir más despacio y esperar." } },
];

const F = [
  "Le jugement des autres m'impacte beaucoup.",
  "Je parle vite.",
  "En groupe, j'aime qu'on respecte ce qui a été prévu : pas de digressions ni d'imprévus.",
  "Dans la vie, je dois me débrouiller seul.",
  "Il faut savoir se mettre en quatre.",
  "J'ai un sentiment d'oppression et la peur de déborder émotionnellement.",
  "J'ai envie d'interrompre les gens pour finir leurs phrases à leur place.",
  "J'ai souvent peur de ne pas être à la hauteur.",
  "Pour être satisfait-e de moi, je dois exceller.",
  "Je dois dépenser beaucoup d'énergie pour faire les choses.",
  "J'aime jouer le rôle de confident.",
  "Il faut dire aux gens ce qu'ils ont envie d'entendre.",
  "J'ai tendance à chercher à comprendre avant d'agir, plutôt qu'à agir pour comprendre.",
  "J'ai du mal à faire confiance.",
  "Le stress, c'est de la motivation.",
  "On dit de moi que je me plains souvent.",
  "En répondant à des questions qui me concernent directement, je me demande si mes réponses correspondent bien à ce qu'on attend de moi.",
  "Je tapote souvent avec mes doigts ou avec mes pieds.",
  "L'exactitude à tout prix.",
  "Je suis convaincu-e que je dois être parmi les meilleur-es.",
  "Pour être aimé-e, il faut être davantage serviable.",
  "J'aime ce qui fait appel à la logique.",
  "Il est important à mes yeux que les autres soient bien disposés à mon égard, que j'aie une bonne image.",
  "Les gens viennent à moi sans que je leur demande : on me trouve abordable.",
  "Je dois donner à penser à mon client que je sais tout.",
  "Je ne me sens pas en confiance si je parle de ce que je ressens.",
  "Je ne peux rester inactif, quitte à faire plusieurs choses en même temps.",
  "J'aime savoir qu'on a besoin de moi.",
  "Je vais trop vite, ce qui me fait faire des fautes d'inattention.",
  "Je suis très exigeant(e) envers moi-même.",
  "J'ai coutume de faire les cent pas lorsque j'attends.",
  "Je dois tout faire pour ne pas être critiqué.",
  "Quand je demande quelque chose à quelqu'un, je m'attends à ce qu'il fasse exactement ce que je lui ai demandé.",
  "Je pense que l'effet est plus important que le résultat.",
  "J'ai toujours l'impression de me battre contre la montre.",
  "Que d'efforts pour répondre à toutes ces questions !",
  "Je ne peux pas déléguer car les autres sont trop lents.",
  "Tant qu'une tâche n'est pas réalisée comme je le souhaite, je recommence.",
  "Je ne sais pas dire « non ».",
  "Mes parents me disaient souvent : « avec un peu plus d'efforts, force-toi, tu peux mieux faire… ».",
  "Je dis souvent « dépêchons-nous, dépêchez-vous, on se dépêche ? ».",
  "Je ne sais pas forcément nommer l'émotion que je ressens, ni l'exprimer.",
  "Je suis disponible pour les autres, même si je n'ai pas envie.",
  "Dans une dispute, je ne m'intéresse qu'aux faits.",
  "Pour être efficace, ma tâche doit être parfaite.",
  "Pour commencer une tâche, il me faut « toutes » les informations.",
  "J'aime accomplir des tâches à responsabilités.",
  "J'ai le sentiment d'être responsable de ce qui arrive aux autres.",
  "J'aime aider les autres.",
  "Je suis souvent à l'origine de situations confuses où on ne comprend pas mes réactions.",
];

const E = [
  "El juicio de los demás me afecta mucho.",
  "Hablo rápido.",
  "En grupo, me gusta que se respete lo que se ha previsto: sin digresiones ni imprevistos.",
  "En la vida, tengo que arreglármelas solo.",
  "Hay que saber desvivirse por los demás.",
  "Siento una opresión y el miedo a desbordarme emocionalmente.",
  "Tengo ganas de interrumpir a la gente para terminar sus frases en su lugar.",
  "A menudo tengo miedo de no estar a la altura.",
  "Para estar satisfecho(a) de mí, tengo que sobresalir.",
  "Tengo que gastar mucha energía para hacer las cosas.",
  "Me gusta desempeñar el papel de confidente.",
  "Hay que decirle a la gente lo que quiere oír.",
  "Tiendo a intentar comprender antes de actuar, en lugar de actuar para comprender.",
  "Me cuesta confiar.",
  "El estrés es motivación.",
  "Dicen de mí que me quejo a menudo.",
  "Al responder a preguntas que me conciernen directamente, me pregunto si mis respuestas se ajustan bien a lo que se espera de mí.",
  "A menudo tamborileo con los dedos o con los pies.",
  "La exactitud a toda costa.",
  "Estoy convencido(a) de que debo estar entre los mejores.",
  "Para ser querido(a), hay que ser más servicial.",
  "Me gusta lo que apela a la lógica.",
  "Es importante para mí que los demás estén bien dispuestos hacia mí, tener una buena imagen.",
  "La gente viene a mí sin que yo lo pida: me encuentran accesible.",
  "Debo hacerle creer a mi cliente que lo sé todo.",
  "No me siento en confianza si hablo de lo que siento.",
  "No puedo quedarme inactivo(a), aunque tenga que hacer varias cosas a la vez.",
  "Me gusta saber que me necesitan.",
  "Voy demasiado rápido, lo que me hace cometer errores por descuido.",
  "Soy muy exigente conmigo mismo(a).",
  "Suelo dar vueltas de un lado a otro cuando espero.",
  "Debo hacer todo lo posible para no ser criticado(a).",
  "Cuando le pido algo a alguien, espero que haga exactamente lo que le he pedido.",
  "Pienso que el efecto es más importante que el resultado.",
  "Siempre tengo la impresión de luchar contra el reloj.",
  "¡Cuántos esfuerzos para responder a todas estas preguntas!",
  "No puedo delegar porque los demás son demasiado lentos.",
  "Mientras una tarea no esté hecha como yo quiero, la vuelvo a empezar.",
  "No sé decir «no».",
  "Mis padres me decían a menudo: «con un poco más de esfuerzo, esfuérzate, puedes hacerlo mejor…».",
  "A menudo digo «démonos prisa, daos prisa, ¿nos damos prisa?».",
  "No siempre sé nombrar la emoción que siento, ni expresarla.",
  "Estoy disponible para los demás, aunque no tenga ganas.",
  "En una discusión, solo me intereso por los hechos.",
  "Para ser eficaz, mi tarea debe ser perfecta.",
  "Para empezar una tarea, necesito «toda» la información.",
  "Me gusta asumir tareas con responsabilidades.",
  "Tengo la sensación de ser responsable de lo que les pasa a los demás.",
  "Me gusta ayudar a los demás.",
  "A menudo soy el origen de situaciones confusas en las que no se entienden mis reacciones.",
];

export const IDR_ITEMS = F.map((text, i) => {
  const n = i + 1;
  const d = DRIVERS.find((dr) => dr.items.includes(n));
  return { n, driver: d.key, fr: text, es: E[i] };
});

// Paliers d'interprétation par driver, en pourcentage (0–100).
export const DRIVER_INTERPRETATION = [
  { min: 0, max: 25, color: "#8A9A6D", fr: "Faible", es: "Bajo" },
  { min: 26, max: 50, color: "#D4A77B", fr: "Modéré", es: "Moderado" },
  { min: 51, max: 75, color: "#E99F4F", fr: "Marqué", es: "Marcado" },
  { min: 76, max: 100, color: "#B0553B", fr: "Très marqué", es: "Muy marcado" },
];

export const IDR_T = {
  fr: {
    allModules: "← Tous les modules",
    welcomeTitle: "Inventaire des Drivers Relationnels",
    welcomeText: "Cet inventaire explore vos « drivers relationnels » : des façons habituelles de penser, de ressentir et d'agir dans la relation. Il comporte 50 affirmations. Répondez spontanément.",
    start: "Commencer",
    consigne: "Consigne",
    consigneP1: "Vous trouverez une série d'affirmations décrivant différentes façons de penser, de ressentir ou d'agir. Pour chacune, indiquez à quel point elle vous correspond, sans chercher la « bonne réponse ».",
    scaleIntro: "Pour chaque affirmation, choisissez le niveau de correspondance :",
    scaleLeft: "Ne me correspond pas du tout",
    scaleRight: "Me correspond totalement",
    sliderHint: "Faites glisser ou cliquez sur un point pour répondre",
    resultsLater: "Vos scores et leur interprétation vous seront présentés uniquement à la fin, une fois les 50 affirmations complétées.",
    prev: "Précédent",
    begin: "Commencer la passation",
    step: "Étape",
    of: "sur",
    seeResults: "Voir mes résultats",
    next: "Suivant",
    completeStep: "Merci de répondre à toutes les affirmations de cette étape pour continuer.",
    thanks: "Merci d'avoir complété l'inventaire",
    thanksText: "Les résultats qui suivent constituent un support de réflexion clinique. Ils ne représentent pas un diagnostic mais une photographie de vos drivers relationnels au moment de cette évaluation.",
    radarTitle: "Radar clinique",
    radarSub: "Diagramme des 5 drivers (0 – 100 %)",
    driversTitle: "Vos drivers",
    driversSub: "Niveau de correspondance de chaque driver, en pourcentage",
    interpTitle: "Interprétation clinique",
    interpSub: "Grille de lecture des scores par driver (en %)",
    pressure: "Niveau",
    clinicalTitle: "Lecture clinique",
    clinicalNote: "Le driver principal correspond au score le plus élevé. L'écart entre les scores renseigne sur la souplesse du fonctionnement relationnel.",
    continueExo: "Pour aller plus loin, poursuivez avec le cahier d'exercices sur vos drivers.",
    continueExoBtn: "Poursuivre avec l'exercice des drivers →",
    exportPdf: "Exporter en PDF",
    restart: "Recommencer",
  },
  es: {
    allModules: "← Todos los módulos",
    welcomeTitle: "Inventario de Drivers Relacionales",
    welcomeText: "Este inventario explora tus «drivers relacionales»: formas habituales de pensar, sentir y actuar en la relación. Consta de 50 afirmaciones. Responde con espontaneidad.",
    start: "Empezar",
    consigne: "Instrucciones",
    consigneP1: "Encontrarás una serie de afirmaciones que describen distintas formas de pensar, sentir o actuar. Para cada una, indica en qué medida te corresponde, sin buscar la «respuesta correcta».",
    scaleIntro: "Para cada afirmación, elige el nivel de correspondencia:",
    scaleLeft: "No me corresponde en absoluto",
    scaleRight: "Me corresponde totalmente",
    sliderHint: "Desliza o haz clic en un punto para responder",
    resultsLater: "Tus puntuaciones y su interpretación se mostrarán únicamente al final, una vez completadas las 50 afirmaciones.",
    prev: "Anterior",
    begin: "Comenzar el cuestionario",
    step: "Etapa",
    of: "de",
    seeResults: "Ver mis resultados",
    next: "Siguiente",
    completeStep: "Responde a todas las afirmaciones de esta etapa para continuar.",
    thanks: "Gracias por completar el inventario",
    thanksText: "Los resultados siguientes constituyen un apoyo de reflexión clínica. No representan un diagnóstico, sino una fotografía de tus drivers relacionales en el momento de esta evaluación.",
    radarTitle: "Radar clínico",
    radarSub: "Diagrama de los 5 drivers (0 – 100 %)",
    driversTitle: "Tus drivers",
    driversSub: "Nivel de correspondencia de cada driver, en porcentaje",
    interpTitle: "Interpretación clínica",
    interpSub: "Guía de lectura de las puntuaciones por driver (en %)",
    pressure: "Nivel",
    clinicalTitle: "Lectura clínica",
    clinicalNote: "El driver principal corresponde a la puntuación más alta. La diferencia entre las puntuaciones informa sobre la flexibilidad del funcionamiento relacional.",
    continueExo: "Para profundizar, continúa con el cuaderno de ejercicios sobre tus drivers.",
    continueExoBtn: "Continuar con el ejercicio de los drivers →",
    exportPdf: "Exportar en PDF",
    restart: "Reiniciar",
  },
};
